export enum KidsCourseAgeGroup {
    Preschool = 1,
    ElementarySchool = 2,
    MiddleSchool = 3,
    HighSchool = 4,
}
